import { createSelector } from 'reselect';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';
import { getMainVideoId } from 'widget/ui-selectors/selected-video-id';
import { getChannelForWidget } from 'shared/selectors/channels';
import { getAvailableVideoType } from 'widget/ui-selectors/video-access';
import { canStartPlaybackInFullScreen } from 'widget/utils/player';


const getVideos = state => state.entities.videos;

/**
* @param state
* @param listType
* @returns main video item
*/
const getMainVideo = createSelector(
  [getVideos, getMainVideoId],
  (videos, mainVideoId) => mainVideoId && videos[mainVideoId]
);


/**
 * @param state
 * @param listType
 * @returns {Boolean}
 */
export const shouldRenderRealPlayer = createSelector(
  [getChannelForWidget, getMainVideo, getCurrentSiteUser],
  (channel, mainVideo, currentSiteUser) => (
    Boolean(
      mainVideo &&
      getAvailableVideoType(channel, mainVideo, currentSiteUser) &&
      canStartPlaybackInFullScreen(mainVideo)
    )
  )
);



// WEBPACK FOOTER //
// ./src/widget/ui-selectors/mobile/should-render-real-player.js